/* global axios */

import ApiClient from './ApiClient';

class RealEstateBrokerCommissionTransfersAPI extends ApiClient {
  constructor() {
    super('real_estate_broker_commission_transfers', { accountScoped: true });
  }

  createTransfer(payload, onUploadProgress) {
    const formData = new FormData();
    formData.append('request_id', payload.requestId);
    formData.append('amount_cents', payload.amountCents);
    formData.append('transferred_on', payload.transferredOn);
    formData.append('observation', payload.observation);
    formData.append('receipt', payload.receipt);
    formData.append('idempotency_key', payload.idempotencyKey);

    return axios.post(this.url, formData, { onUploadProgress });
  }

  downloadReceipt(id) {
    return axios.get(`${this.url}/${id}/download_receipt`);
  }
}

export default new RealEstateBrokerCommissionTransfersAPI();
